import Cookie from 'cookie-universal';
export const cookies = Cookie();

const COOKIE_MAX_AGE = 1000 * 60 * 60 * 24 * 7 * 356;

export const COOKIE_OPTIONS = {
  path: '/',
  maxAge: COOKIE_MAX_AGE,
  expires: new Date(Date.now() + COOKIE_MAX_AGE)
};

export const COOKIE_REMOVE_OPTIONS = {
  path: '/'
};

export const COMMON_COOKIES_MAP = {
  brandName: {
    key: 'ecx-novated-brand-key',
    lookup: 'utm_source'
  }
};

/**
 * Returns the value of a cookie by the given cookie key name
 *
 * @param key The key ID of the cookie to return
 * @returns {any}
 */
export function getCookie(key) {
  return cookies.get(key);
}

/**
 * Sets a cookie using defaulted options
 *
 * @param key The key of the cookie to store
 * @param value The value of the cookie to store
 * @param options The storage options
 */
export function setCookie(key, value, options = COOKIE_OPTIONS) {
  cookies.set(key, value, options);
}

/**
 * Removes a cookie using defaulted options
 *
 * @param key The key of the cookie to remove
 * @param options The removal options
 */
export function removeCookie(key, options = COOKIE_REMOVE_OPTIONS) {
  cookies.remove(key, options);
}

/**
 * Store cookie data from the to route query parameters.
 * This will only store a cookie if the lookup key exists as a truthy value
 * within the vue router query parameters.
 *
 * @param storageList A list of Objects consisting of a key (cookie key to store) and lookup (query param lookup)
 */
export const storeQueryCookiesGuard = (storageList = []) => {
  return (to = {}, from = {}, next = () => {}) => {
    const list = [...Object.values(COMMON_COOKIES_MAP), ...storageList];
    list.forEach(({ key, lookup }) => {
      if (to.query[lookup]) {
        setCookie(key, to.query[lookup]);
      }
    });
    next();
  };
};
